// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".autocomplete-ytj-haku__no-data-text {\n  max-width: 400px;\n}", ""]);
// Exports
module.exports = exports;
